import type { KeyboardEvent } from 'react';
import type { IntegrationApi } from '../connectionTypes';

type ImportWizardIntegrationSidebarProps = {
  connections: IntegrationApi[];
  selectedConnectionId: string;
  onSelectConnection: (connectionId: string) => void;
};

export const ImportWizardIntegrationSidebar = ({
  connections,
  selectedConnectionId,
  onSelectConnection,
}: ImportWizardIntegrationSidebarProps) => (
  <>
    {connections.map((connection) => {
      const selected = connection.id === selectedConnectionId;
      const activate = () => onSelectConnection(connection.id);
      const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      };
      return (
        <div
          key={connection.id}
          role="button"
          tabIndex={0}
          aria-pressed={selected}
          className={
            selected
              ? 'import-wizard__provider import-wizard__provider--selected'
              : 'import-wizard__provider'
          }
          onClick={activate}
          onKeyDown={onKeyDown}
        >
          {connection.name}
        </div>
      );
    })}
  </>
);
